import FormRequest from "@/api/FormRequest";

export default class UpdateFormRequest extends FormRequest {
  public commentMentionNotifications?: boolean;
  public image?: File;
}
